import { useParams } from 'react-router-dom'
import { MemberDetailPage } from '@/components/members/member-detail-page'

export function CommitteeMemberDetail() {
  const { id } = useParams<{ id: string }>()
  if (!id) return null

  return (
    <MemberDetailPage
      memberId={id}
      listPath="/committee/members"
      canDelete={false}
      canManageRole={false}
      canManagePlots={false}
    />
  )
}
